import { Component, OnInit, OnDestroy } from '@angular/core';
import * as THREE from 'three';
import { trigger, transition, animate, style, state } from '@angular/animations';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { CSS3DRenderer, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
import { RouletPhysicsService } from '../core/services/roulet-physics.service';
import { AuthorizationService } from '../core/services/authorization.service';
import { GameService } from '../core/services/game.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../environments/environment';


const degree = Math.PI / 180;

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.css'],
  animations: [
    trigger('slideInOut', [
      state('*', style({ transform: 'translateX(0%)', opacity: 1 })),
      transition('void => *', [style({ transform: 'translateX(100%)', opacity: 0 }), animate(500)]),
      transition('* => void', animate(500, style({ transform: 'translateX(100%)', opacity: 0 })))
    ]),
  ]
})

export class GameComponent implements OnInit, OnDestroy {
  animateId: any;
  lightScrollbarOptions = { axis: 'y', theme: 'light-thick' };
  container: any;
  stats: any;
  controls: any;
  plane: THREE.Mesh;
  camera: any;
  scene: THREE.Scene;
  scene2: THREE.Scene;
  renderer: any;
  renderer2: CSS3DRenderer;
  light: THREE.Light;
  html: any;
  ball: THREE.Mesh;
  textMeshes = [];
  isFullyLoaded: boolean = false;
  betCoin: any;
  loader = new FBXLoader();
  clock = new THREE.Clock();
  textureLoader = new THREE.TextureLoader();
  width = window.innerWidth;
  height = window.innerHeight;
  Q: number = 0;
  w: number = 0;
  a: number = 0;
  r: number = 0;
  cofficient: number = 0;
  rt: number = 0;
  cf: number = 0;
  k: number = 0;
  settings = {
    metalness: 0.8,
    roughness: 0.1,
    envMapIntensity: 0.5,
    displacementScale: 2.436143,
    normalScale: 1.0
  };
  matColor = [];
  wheel: any;
  rouletTable: any;
  bowl: any;
  htmlPlane: any;
  blueChip: any;
  greenChip: any;
  skyBlueChip: any;
  redChip: any;
  pinkChip: any;
  orangeChip: any;

  reflectionCube: any;

  isTeamSizeDDOpened: boolean = false;
  isbetAmountDDOpened: boolean = false;
  isProbabilityDDOpened: boolean = false;
  isWinModelOpened: boolean = false;
  isLooseModelOpened: boolean = false;

  selectedTeamSize: number = 2;
  selectedBetAmount: number = 10;
  selectedProbability: number = 50;
  winAmount: number = this.calculateWinAmount();
  probabilityArray: any;
  multiplierArray: any;
  spinStarted: boolean = false;
  isBetPlaced: boolean = false;
  casinoAudio: any;
  buttonClickAudio: any;
  wheelSpinAudio: any;
  betAudion: any;
  winAudio: any;
  looseAudio: any;
  collectAudio: any;
  isAudio: boolean = true;
  isBetModalOpened: boolean = false;
  isConfirmBetModalOpened: boolean = false;
  isReBetReady: boolean = true;
  audioIcon: string = '../../assets/images/soundoff.png';
  hiddenCardImg: string = '../../assets/images/dafult-card.png';

  cardNumbersArray: any;
  isCardActive: any = [];
  isCardSelected: boolean = false;
  selectedCard: string = '#';
  serverCard: string = this.hiddenCardImg;
  betInfo = {};
  userInfo = {};
  balance: number = 0;
  bankBalance: number = 0;
  cardAnimation: boolean = false;
  show: boolean = false;
  showChangeBetModal: boolean = false;

  isDarkTheme: boolean = true;

  mdlSampleIsOpen: boolean = false;

  contestEnvEndDate:Date = environment.contestEndDate;
  contestEnd : boolean = false;

  constructor(
    private roulettPhysics: RouletPhysicsService,
    private gameService: GameService,
    private authService: AuthorizationService,
    private deviceDetector: DeviceDetectorService
  ) { }

  ngOnInit() {
    if (Math.random() * 10 < 5) this.isDarkTheme = false;

    this.userInfo = this.authService.retrieveUserDetails();

    this.cardNumbersArray = Array(13).fill(0).map((x, i) => {
      this.isCardActive.push(false);
      return i;
    });

    this.init();
    this.animate();
  }

  ngOnDestroy() {
    this.flush();
  }

  init() {

    let path = "../../assets/images/SwedishRoyalCastle/";
    let format = '.jpg';
    let urls = [
      path + 'px' + format, path + 'nx' + format,
      path + 'py' + format, path + 'ny' + format,
      path + 'pz' + format, path + 'nz' + format
    ];

    this.reflectionCube = new THREE.CubeTextureLoader().load(urls);

    Promise.all<any>([
      this.addCamera(),
      this.addScenes(),
      this.addLights(),
      this.addGround(),
      this.addRoulettable(),
      this.addBowl(),
      this.addRoulettWheel(),
      this.addBall(),
      this.addPiles(),

      this.initializeSounds()
    ]).then(values => {
      console.log('Game Loaded Successfully', values);
      setTimeout(() => {
        this.isFullyLoaded = true;
        this.show = true;
      }, 5000);
    }).catch(err => {
      console.error('Some part of game having trouble while loading', err);
    });

    this.renderThings();
    this.addMouseControl();

    this.addStat();

    this.bindEvents();
  }

  onWindowResize(e, t) {
    t.width = window.innerWidth * 0.99;
    t.height = window.innerHeight * 0.99;

    t.camera.aspect = t.width / t.height;
    t.camera.updateProjectionMatrix();

    t.renderer.setSize(t.width, t.height);
    t.renderer2.setSize(t.width, t.height);

  }

  animate() {
    // var delta = this.clock.getDelta();
    if (this.ball) {
      if (this.r > 260) {
        if (this.wheel) {
          this.wheel.rotation.y = this.w;
          this.w += this.a;
        }

        this.Q += this.a;
        this.ball.rotation.y += -Math.PI / 60;
        this.ball.position.x = this.r * Math.cos(this.Q) + 0;
        this.ball.position.z = this.r * Math.sin(this.Q) + 0;

        this.a -= this.rt;
        this.r -= this.cf;
      } else {
        if (this.cofficient > 0) {
          this.Q -= this.a;
          this.wheel.rotation.y += this.cofficient;
          this.ball.rotation.y += Math.PI / 60;
          this.ball.position.x = this.r * Math.cos(this.Q) + 0;
          this.ball.position.z = this.r * Math.sin(this.Q) + 0;

          this.cofficient -= this.k;
        } else {
          if (this.spinStarted) {
            this.spinEnded();
          }
        }
      }
    }

    setTimeout(() => {
      this.animateId = requestAnimationFrame(() => {
        this.animate();
      });
    }, 1000 / 20)


    this.renderer.render(this.scene, this.camera);
    this.renderer2.render(this.scene2, this.camera);
    // this.controls.update();
    this.stats.update();
  }

  spinEnded() {
    this.spinStarted = false;
    this.serverCard = this.hiddenCardImg;
    if (this.isAudio)
      this.wheelSpinAudio.stop();
    this.openWinLooseModel();
    this.resetGame();
  }

  betAmountDD() {
    this.isbetAmountDDOpened = !this.isbetAmountDDOpened;
    this.isProbabilityDDOpened = false;
  }
  probabilityDD() {
    this.isProbabilityDDOpened = !this.isProbabilityDDOpened;
    this.isbetAmountDDOpened = false;
  }

  openWinLooseModel() {
    if (this.betInfo['result']) {
      this.isWinModelOpened = true;
      this.updateBalance(true);
      if (this.isAudio) {
        this.winAudio.play();
        this.collectAudio.play();
      }
      return;
    }
    if (this.isAudio) {
      this.looseAudio.play();
      this.collectAudio.play();
    }
    this.isLooseModelOpened = true;
    this.updateBalance(false);
    return;
  }

  updateBetAmount(value) {
    this.playButtonSound();
    this.selectedBetAmount = value;
    this.isbetAmountDDOpened = false;
    this.winAmount = this.calculateWinAmount();
  }
  updateProbability(value) {
    this.playButtonSound();
    this.selectedProbability = value;
    this.isProbabilityDDOpened = false;
    this.winAmount = this.calculateWinAmount();
    this.calculateWiningArea(value, 100 - value);
    this.calculateTextParams(100 - value, false);
    this.setDefault();
  }

  calculateWinAmount() {
    return Math.floor(((100 - this.selectedProbability) / this.selectedProbability) * this.selectedBetAmount);
  }

  round(value: number, precision: number): number {
    var multiplier = Math.pow(10, precision || 0);
    return Number((Math.round(Number((value * multiplier).toFixed(precision + 1))) / multiplier).toFixed(precision));
  }

  setDefault() {
    this.wheel.rotation.y = 90 * degree;
  }

  clearPrecentageText() {
    for (let mesh of this.wheel.children) {
      if (mesh.name === 'win' || mesh.name === 'loose')
        this.wheel.remove(mesh);
    }
  }

  clearBet() {
    this.playButtonSound();
    this.resetGame();
  }

  resetGame() {
    this.isBetPlaced = false;
    this.isBetModalOpened = false;
    this.isCardSelected = false;
    this.selectedCard = '';
    this.serverCard = this.hiddenCardImg;
    this.removeActiveFromCard();
  }

  removeTexts() {
    for (let i = 0; i < this.textMeshes.length; i++)
      this.wheel.remove(this.textMeshes[i])
  }

  getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }

  openBetModal() {
    const params = {
      bet: this.selectedBetAmount,
      winningProbability: this.selectedProbability
    };
    if (new Date() > this.contestEnvEndDate) {
      this.contestEnd = true;
      this.isBetModalOpened = true;
      return;
    }
    this.gameService.betInit(params)
      .takeUntil(componentDestroyed(this))
      .subscribe(res => {
        this.betInfo = Object.assign(this.betInfo, res);
        this.playButtonSound();
        this.isBetModalOpened = true;
      });
  }

  closeBetModal() {
    this.playButtonSound();
    this.isBetModalOpened = false;
    this.selectedCard = '#';
    this.removeActiveFromCard();
    this.isCardSelected = false;
    this.betInfo = {};
  }

  playButtonSound() {
    if (this.isAudio)
      this.buttonClickAudio.play();
  }

  rotateWheel() {
    this.isBetModalOpened = false;
    const params = this.roulettPhysics.get();
    this.Q = params.Q;
    this.w = params.w;
    this.a = params.a;
    this.r = params.r;
    this.cofficient = params.cofficient;
    this.rt = params.rt;
    this.cf = params.cf;
    this.k = params.k;
    this.spinStarted = true;

    if (this.isAudio)
      this.wheelSpinAudio.play();

    this.isBetPlaced = false;
  }

  calculateWiningArea(win, loss) {
    let green = Math.floor((66 * Number(win) * 0.01));
    let red = Math.ceil((66 * Number(loss) * 0.01));

    console.log('BEFORE INCREMENT :: ', red);

    if (red % 2 == 0) {
      red--
    }

    this.matColor = [];
    for (let i = 0; i < green; i++) {
      this.matColor.push('#11662b');
    }
    for (let i = 0; i < red; i++) {
      this.matColor.push('#780006');
    }

    var obj;
    for (let i = 0; i < this.wheel.children.length; i++) {
      let mesh = this.wheel.children[i];
      if (mesh.name === 'root')
        obj = mesh;
    }
    var parent = this;
    obj.traverse((child) => {
      parent.updateWiningArea(child);
    });
  }

  updateWiningArea(child) {
    if (child['isMesh']) {

      child.castShadow = false;
      child.receiveShadow = false;

    }

    if (child instanceof THREE.Mesh) {
      if (child.name === 'node_id4') {
        child.material = new THREE.MeshStandardMaterial({
          color: 0xffffff,
          roughness: this.settings.roughness,
          metalness: this.settings.metalness,
          envMapIntensity: this.settings.envMapIntensity,
          envMap: this.reflectionCube
        })
      } else if (child.name === 'node_id204' || child.name === 'node_id206') {
        child.material = new THREE.MeshPhongMaterial({
          transparent: true,
          wireframe: true,
          opacity: 0
        });
      } else if (Number(child.name.replace(/^\D+/g, '')) % 6 === 0) {
        child.material = new THREE.MeshPhongMaterial({
          transparent: true,
          wireframe: true,
          opacity: 0
        });
      } else {
        child.material = new THREE.MeshStandardMaterial({
          color: this.matColor.pop(),
          roughness: 0.5,
          metalness: 0.2,
          envMapIntensity: this.settings.envMapIntensity,
          envMap: this.reflectionCube
        });
      }

      child.material.needsUpdate = true;
    }
  }

  initializeSounds() {
    var t = this;
    var listener = new THREE.AudioListener();
    this.camera.add(listener);

    var audioLoader = new THREE.AudioLoader();

    t.casinoAudio = new THREE.Audio(listener);
    t.buttonClickAudio = new THREE.Audio(listener);
    t.wheelSpinAudio = new THREE.Audio(listener);
    t.betAudion = new THREE.Audio(listener);
    t.winAudio = new THREE.Audio(listener);
    t.looseAudio = new THREE.Audio(listener);
    t.collectAudio = new THREE.Audio(listener);

    audioLoader.load('../../assets/audio/Sappheiros_Lights.mp3', function (buffer) {
      t.casinoAudio.setBuffer(buffer);
      t.casinoAudio.setLoop(true);
      t.casinoAudio.setVolume(0.8);
      t.casinoAudio.play();
    }, (progress) => {
      console.log(progress);
    }, (error) => {
      console.error(error);
    });

    audioLoader.load('../../assets/audio/press_but.mp3', function (buffer) {
      t.buttonClickAudio.setBuffer(buffer);
      t.buttonClickAudio.setLoop(false);
      t.buttonClickAudio.setVolume(0.8);
    }, (progress) => {
      console.log(progress);
    }, (error) => {
      console.error(error);
    });

    audioLoader.load('../../assets/audio/wheel_sound.mp3', function (buffer) {
      t.wheelSpinAudio.setBuffer(buffer);
      t.wheelSpinAudio.setLoop(false);
      t.wheelSpinAudio.setVolume(0.8);
    }, (progress) => {
      console.log(progress);
    }, (error) => {
      console.error(error);
    });

    audioLoader.load('../../assets/audio/chip.mp3', function (buffer) {
      t.betAudion.setBuffer(buffer);
      t.betAudion.setLoop(false);
      t.betAudion.setVolume(0.8);
    }, (progress) => {
      console.log(progress);
    }, (error) => {
      console.error(error);
    });

    audioLoader.load('../../assets/audio/win.wav', function (buffer) {
      t.winAudio.setBuffer(buffer);
      t.winAudio.setLoop(false);
      t.winAudio.setVolume(0.8);
    }, (progress) => {
      console.log(progress);
    }, (error) => {
      console.error(error);
    });

    audioLoader.load('../../assets/audio/loose.wav', function (buffer) {
      t.looseAudio.setBuffer(buffer);
      t.looseAudio.setLoop(false);
      t.looseAudio.setVolume(0.8);
    }, (progress) => {
      console.log(progress);
    }, (error) => {
      console.error(error);
    });

    audioLoader.load('../../assets/audio/collect.mp3', function (buffer) {
      t.collectAudio.setBuffer(buffer);
      t.collectAudio.setLoop(false);
      t.collectAudio.setVolume(0.8);
    }, (progress) => {
      console.log(progress);
    }, (error) => {
      console.error(error);
    });
  }

  playSound() {
    this.isAudio = !this.isAudio;
    if (!this.isAudio) {
      this.casinoAudio.pause();
      this.audioIcon = '../../assets/images/soundon.png';
      return;
    }
    this.casinoAudio.play();
    this.audioIcon = '../../assets/images/soundoff.png'
  }

  initializeWinArea() {
    return new Promise(async (resolve, reject) => {
      this.calculateTextParams('50.0');
      for (let i = 0; i < 33; i++) {
        this.matColor.push('#11662b');
      }
      for (let i = 0; i < 33; i++) {
        this.matColor.push('#780006');
      }
      resolve(true);
    });
  }

  async calculateTextParams(prob, isWin = true) {
    if (!isWin)
      prob = (100 - prob).toFixed(1);

    this.roulettPhysics.set(prob, true);
    const params = this.roulettPhysics.get();
    await this.addText(prob, 'win', this.wheel, new THREE.Vector3(params.tp[0], params.tp[1], params.tp[2]), new THREE.Euler(params.tr[0], params.tr[1], params.tr[2]));
    await this.addText((100.0 - prob).toFixed(1), 'loose', this.wheel, new THREE.Vector3(params.tp_o[0] + 100, params.tp_o[1], params.tp_o[2]), new THREE.Euler(params.tr_o[0], params.tr_o[1], params.tr_o[2]));
  }

  addCamera() {
    this.camera = new THREE.PerspectiveCamera(60, this.width / this.height, 10, 10000);
    this.camera.position.x = 0;
    this.camera.position.y = this.deviceDetector.isMobile() ? 4000 : 3000;
    this.camera.position.z = 600;

    this.camera.rotation.x = 60 * degree;
    this.camera.rotation.y = 0 * degree;
    this.camera.rotation.z = 0 * degree;
  };

  addScenes() {
    this.scene = new THREE.Scene();
    if (!this.isDarkTheme) {
      this.scene.background = new THREE.Color(0xcce0ff);
      this.scene.fog = new THREE.Fog(0xcce0ff, 500, 20000);
    }
    this.scene2 = new THREE.Scene();

    const z = this.deviceDetector.isMobile() ? -400 : 0;
    this.scene.position.set(2, 50, z);
    this.scene2.position.set(2, 50, z);
  }

  addGround() {
    if (this.isDarkTheme) {
      var floor = this.textureLoader.load("../../assets/images/floorCloth.png");
      floor.wrapS = floor.wrapT = THREE.RepeatWrapping;
      floor.offset.set(0, 0);
      floor.repeat.set(3, 3);

      var mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(12000, 12000), new THREE.MeshStandardMaterial({ map: floor, depthWrite: true, transparent: true, opacity: 0.3 }));
      mesh.position.set(0, 0, 0);
      mesh.rotation.x = - Math.PI / 2;
      mesh.castShadow = false;
      mesh.receiveShadow = true;

      this.scene.add(mesh);
      return;
    }

    //light theme
    var groundTexture = this.textureLoader.load('../../assets/images/grasslight-big.jpg');
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(25, 25);
    groundTexture.anisotropy = 16;
    var groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });
    var mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(20000, 20000), groundMaterial);
    mesh.position.y = - 250;
    mesh.rotation.x = - Math.PI / 2;
    mesh.receiveShadow = true;
    this.scene.add(mesh);

  }

  addRoulettWheel() {
    var loader1 = new THREE.ObjectLoader();
    var parent = this;
    return new Promise((resolve, reject) => {
      loader1.load('../../assets/models/model.json', function (object) {
        object.traverse(function (child) {
          child.castShadow = true;
          child.receiveShadow = true;
          if (child['isMesh']) {

            child.castShadow = true;
            child.receiveShadow = true;

          }

          if (child instanceof THREE.Mesh) {
            child.material = [
              new THREE.MeshStandardMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/WoodTop.png'),
                roughness: 0.3,
                metalness: 0,
                envMapIntensity: parent.settings.envMapIntensity,
                envMap: parent.reflectionCube
              }),
              new THREE.MeshStandardMaterial({
                color: 0xffffff,
                roughness: parent.settings.roughness,
                metalness: parent.settings.metalness,
                envMapIntensity: parent.settings.envMapIntensity,
                envMap: parent.reflectionCube,
                side: THREE.DoubleSide
              }),
              new THREE.MeshStandardMaterial({
                roughness: parent.settings.roughness,
                metalness: 0.7,
                envMapIntensity: parent.settings.envMapIntensity,
                envMap: parent.reflectionCube,
                side: THREE.DoubleSide
              }),
              new THREE.MeshStandardMaterial({
                color: 0xffffff,
                roughness: parent.settings.roughness,
                metalness: 0.7,
                envMapIntensity: parent.settings.envMapIntensity,
                envMap: parent.reflectionCube,
                side: THREE.DoubleSide
              })
            ];
          }
        });

        var object3D = new THREE.Object3D();

        parent.loader.load('../../assets/models/fbx/rotor_colliders.fbx', function (object) {

          object.traverse(function (child) {
            parent.updateWiningArea(child);

            object.position.set(0, 737, -378);
            object.scale.set(1475, 1475, 1475);
            object3D.add(object);
          });
        }, undefined, (err) => {
          console.error(err);
          reject(err);
        });


        object.position.set(0, 815, 0);

        object3D.add(object);
        object3D.rotation.y = 90 * degree;
        parent.wheel = object3D;
        parent.scene.add(object3D);
        parent.initializeWinArea();

        resolve(true);
      }, undefined, (err) => {
        console.error(err);
        reject(err);
      });
    });

  }

  addRoulettable() {
    let t = this;
    return new Promise((resolve, reject) => {
      t.loader.load('../../assets/models/fbx/roulettetable.fbx', function (object) {
        object.traverse(function (child) {

          if (child['isMesh']) {

            child.castShadow = true;
            child.receiveShadow = false;

          }

          if (child instanceof THREE.Mesh) {

            var texture = t.textureLoader.load('../../assets/images/leather.jpg', function (texture) {

              texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
              texture.offset.set(0, 0);
              texture.repeat.set(50, 50);

            });

            var dashboard = t.textureLoader.load('../../assets/images/greencloth.png');

            child.material = [
              new THREE.MeshStandardMaterial({
                map: dashboard,
                blending: THREE.NoBlending,
                roughness: 2,
                side: THREE.DoubleSide,
              }),
              new THREE.MeshPhysicalMaterial({
                map: texture
              }),
              new THREE.MeshPhysicalMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/Gradient Diagonal (Color).jpg'),
                side: THREE.DoubleSide
              }),
              new THREE.MeshStandardMaterial({
                color: 'orange',
                side: THREE.DoubleSide,
                roughness: 0.4,
                metalness: 0.6,
                envMapIntensity: t.settings.envMapIntensity,
                envMap: t.reflectionCube
              }),
              new THREE.MeshStandardMaterial({
                color: 0xffffff,
                roughness: t.settings.roughness,
                metalness: t.settings.metalness,
                envMapIntensity: t.settings.envMapIntensity,
                envMap: t.reflectionCube,
                transparent: true,
                opacity: 0.6
              }),
              new THREE.MeshStandardMaterial({
                color: 0xffffff,
                roughness: 0,
                metalness: 0.7,
                envMapIntensity: t.settings.envMapIntensity,
                envMap: t.reflectionCube
              }),
              new THREE.MeshPhysicalMaterial({
                color: 0x474645
              })
            ];
          }
        });

        object.position.set(0, 400, 37);

        var object3D = new THREE.Object3D;

        object3D.add(object);

        var positionVector = new THREE.Vector3();
        var box = new THREE.Box3().setFromObject(object);
        box.getSize(positionVector);

        // console.log(box.min, box.max, box.getSize(positionVector));

        t.scene.add(object3D);
        var dom = document.getElementById('battingUI');
        dom.style.height = positionVector.z * 0.53 + 'px';
        dom.style.width = positionVector.x * 0.85 + 'px';

        t.html = new CSS3DObject(dom);
        t.html.position.y = 700;
        t.html.position.z = 850;
        t.html.rotation.copy(object.rotation);
        t.html.rotation.x = -90 * degree;
        t.html.scale.copy(object.scale);

        t.html.buffersNeedUpdate = true;
        t.html.uvsNeedUpdate = true;

        t.scene2.add(t.html);

        var material = new THREE.MeshBasicMaterial({
          map: THREE.ImageUtils.loadTexture('../../assets/images/greencloth.png'),
          transparent: true,
          opacity: 0,
          wireframe: true,
          wireframeLinewidth: 1,
          side: THREE.DoubleSide
        });

        var geometry = new THREE.PlaneGeometry(positionVector.x * 0.85, positionVector.z * 0.53);
        var planeMesh = new THREE.Mesh(geometry, material);

        planeMesh.position.copy(t.html.position);
        planeMesh.rotation.copy(t.html.rotation);
        planeMesh.scale.copy(t.html.scale);

        object3D.add(planeMesh);

        t.htmlPlane = planeMesh;
        t.rouletTable = object3D;

        resolve(true);

      }, undefined, (err) => {
        console.error(err);
        reject(err);
      });
    });
  }

  addBowl() {
    let t = this;
    return new Promise((resolve, reject) => {
      t.loader.load('../../assets/models/fbx/bowl.fbx', function (object) {

        object.traverse(function (child) {

          if (child['isMesh']) {

            child.castShadow = true;
            child.receiveShadow = false;

          }
          if (child instanceof THREE.Mesh) {
            child.material = [
              new THREE.MeshStandardMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/bowltexture.png'),
                roughness: 0.3,
                metalness: 0,
                envMapIntensity: t.settings.envMapIntensity,
                envMap: t.reflectionCube,
                side: THREE.DoubleSide
              }),
              new THREE.MeshStandardMaterial({
                color: 0xFF8C00,
                roughness: t.settings.roughness,
                metalness: t.settings.metalness,
                envMapIntensity: t.settings.envMapIntensity,
                envMap: t.reflectionCube,
                side: THREE.DoubleSide
              }),
              new THREE.MeshStandardMaterial({
                color: 0xffffff,
                roughness: t.settings.roughness,
                metalness: 0.6,
                envMapIntensity: t.settings.envMapIntensity,
                envMap: t.reflectionCube,
                side: THREE.DoubleSide
              })
            ];
          }

        });
        object.position.set(0, 408, 40);
        t.scene.add(object);
        t.bowl = object;
        resolve(true);
      }, undefined, (error) => {
        console.error(error);
        reject(error);
      });
    });
  }

  addBall() {
    return new Promise((resolve, reject) => {
      let ballGeometry = new THREE.SphereGeometry(20, 30, 30);
      let ballMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xffffff,
        roughness: 0,
        metalness: 0.4,
        envMapIntensity: this.settings.envMapIntensity,
        envMap: this.reflectionCube
      });
      this.ball = new THREE.Mesh(ballGeometry, ballMaterial);
      this.ball.position.set(500, 720, 0);
      this.scene.add(this.ball);
      resolve(true);
    });
  }

  addPiles() {
    let t = this;
    return new Promise((resolve, reject) => {
      let pile1 = new Promise((resolve, reject) => {
        t.loader.load('../../assets/models/fbx/chips fbx/bluepile.fbx', function (object) {
          object.traverse(function (child) {

            if (child['isMesh']) {

              child.castShadow = true;
              child.receiveShadow = true;

            }

            if (child instanceof THREE.Mesh) {
              child.material = new THREE.MeshPhysicalMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/bluechip.png')
              });
            }

          });
          object.position.set(-40, -170, 4200);
          object.scale.set(2.4, 2.4, 6);
          object.rotation.y = 0 * degree;
          t.scene.add(object);

          var bluePile2 = object.clone();
          bluePile2.position.set(60, -170, 4200);
          bluePile2.scale.set(2.4, 2.4, 6);
          bluePile2.rotation.y = 0 * degree;
          t.scene.add(bluePile2);
          resolve(true);
        }, undefined, (err) => {
          reject(err);
        });
      });

      let pile2 = new Promise((resolve, reject) => {
        t.loader.load('../../assets/models/fbx/chips fbx/blueskypile.fbx', function (object) {

          object.traverse(function (child) {

            if (child['isMesh']) {

              child.castShadow = true;
              child.receiveShadow = true;

            }

            if (child instanceof THREE.Mesh) {
              child.material = new THREE.MeshPhysicalMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/blueskychip.png')
              });
            }

          });
          object.position.set(-210, -170, 4200);
          object.scale.set(2.4, 2.4, 6);
          object.rotation.y = 0 * degree;
          t.scene.add(object); resolve(true);
        }, undefined, (err) => {
          reject(err);
        });
      });

      let pile3 = new Promise((resolve, reject) => {
        t.loader.load('../../assets/models/fbx/chips fbx/greenpile.fbx', function (object) {
          object.traverse(function (child) {

            if (child['isMesh']) {

              child.castShadow = true;
              child.receiveShadow = true;

            }

            if (child instanceof THREE.Mesh) {
              child.material = new THREE.MeshPhysicalMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/greenchip.png'),
                transparent: true,
                opacity: 0.8
              });
            }

          });
          object.position.set(-480, -170, 4200);
          object.scale.set(2.4, 2.4, 6);
          object.rotation.y = 0 * degree;
          t.scene.add(object);

          var greenPile2 = object.clone();
          greenPile2.position.set(-380, -170, 4200);
          greenPile2.scale.set(2.4, 2.4, 6);
          greenPile2.rotation.y = 0 * degree;
          t.scene.add(greenPile2);
          resolve(true);
        }, undefined, (err) => {
          reject(err);
        });
      });

      let pile4 = new Promise((resolve, reject) => {
        t.loader.load('../../assets/models/fbx/chips fbx/orangepile.fbx', function (object) {
          object.traverse(function (child) {

            if (child['isMesh']) {

              child.castShadow = true;
              child.receiveShadow = true;

            }

            if (child instanceof THREE.Mesh) {
              child.material = new THREE.MeshPhysicalMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/orangechip.png')
              });
            }

          });
          object.position.set(1455, -170, 4200);
          object.scale.set(2.4, 2.4, 6);
          object.rotation.y = 0 * degree;
          t.scene.add(object);

          var orangepile2 = object.clone();
          orangepile2.position.set(1550, -170, 4200);
          orangepile2.scale.set(2.4, 2.4, 6);
          orangepile2.rotation.y = 0 * degree;
          t.scene.add(orangepile2);
          resolve(true);
        }, undefined, (err) => {
          reject(err);
        });
      });


      let pile5 = new Promise((resolve, reject) => {
        t.loader.load('../../assets/models/fbx/chips fbx/pinkpile.fbx', function (object) {

          object.traverse(function (child) {

            if (child['isMesh']) {

              child.castShadow = true;
              child.receiveShadow = true;

            }

            if (child instanceof THREE.Mesh) {
              child.material = new THREE.MeshPhysicalMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/pinkchip.png')
              });
            }

          });
          object.position.set(1930, -170, 4200);
          object.scale.set(2.4, 2.4, 6);
          object.rotation.y = 0 * degree;
          t.scene.add(object);
          resolve(true);
        }, undefined, (err) => {
          reject(err);
        });
      });


      let pile6 = new Promise((resolve, reject) => {
        t.loader.load('../../assets/models/fbx/chips fbx/redpile.fbx', function (object) {

          object.traverse(function (child) {

            if (child['isMesh']) {

              child.castShadow = true;
              child.receiveShadow = true;

            }

            if (child instanceof THREE.Mesh) {
              child.material = new THREE.MeshPhysicalMaterial({
                map: THREE.ImageUtils.loadTexture('../../assets/images/redchip.png')
              });
            }

          });
          object.position.set(1570, -170, 4200);
          object.scale.set(2.4, 2.4, 6);
          object.rotation.y = 0 * degree;
          t.scene.add(object);

          var redPile2 = object.clone();

          redPile2.position.set(1665, -170, 4200);
          redPile2.scale.set(2.4, 2.4, 6);
          redPile2.rotation.y = 0 * degree;
          t.scene.add(redPile2);
          resolve(true);
        }, undefined, (err) => {
          reject(err);
        });
      });
      Promise.all([pile1, pile2, pile3, pile4, pile5, pile6]).then(function (values) {
        resolve(true);
      }).catch(err => reject(err));
    });
  }

  addLights() {
    if (this.isDarkTheme) {
      var pointLight = new THREE.PointLight(0Xffffff, 1, 2000, 2);
      pointLight.position.set(0, 1500, 0);
      this.scene.add(pointLight);

      var dirLight = new THREE.DirectionalLight(0xffffff, 0.6);
      dirLight.position.set(-50, 2000, -300);
      dirLight.target.position.set(0, 0, 0);
      dirLight.castShadow = true;
      this.scene.add(dirLight);
      this.scene.add(dirLight.target);

      var d = 2000;

      dirLight.shadowCameraLeft = -d;
      dirLight.shadowCameraRight = d;
      dirLight.shadowCameraTop = d;
      dirLight.shadowCameraBottom = -d;

      dirLight.shadowCameraFar = 3500;
      dirLight.shadowBias = -0.0001;

      var hamiSphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.4);
      this.scene.add(hamiSphereLight);
      return;
    }

    this.scene.add(new THREE.AmbientLight(0x666666));
    var light = new THREE.DirectionalLight(0xdfebff, 1);
    light.position.set(50, 200, 100);
    light.position.multiplyScalar(1.3);
    light.castShadow = true;
    light.shadow.mapSize.width = 1024;
    light.shadow.mapSize.height = 1024;
    var d = 300;
    light.shadow.camera.left = - d;
    light.shadow.camera.right = d;
    light.shadow.camera.top = d;
    light.shadow.camera.bottom = - d;
    light.shadow.camera.far = 1000;
    this.scene.add(light);
  }

  renderThings() {
    let gameContainer = document.getElementById('container');
    this.renderer2 = new CSS3DRenderer();
    this.renderer2.setSize(this.width, this.height);
    this.renderer2.domElement.style.position = 'absolute';
    this.renderer2.domElement.style.top = '0';
    this.renderer2.domElement.style.zIndex = '0';

    gameContainer.appendChild(this.renderer2.domElement);

    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setClearColor(0x000000, 0);
    this.renderer.setSize(this.width, this.height);
    this.renderer.domElement.style.zIndex = '1';
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

    gameContainer.appendChild(this.renderer.domElement);
  }

  addMouseControl() {
    try {
      this.controls = new OrbitControls(this.camera, document.getElementById('container'));
      this.controls.target.set(0, 0, 0);
      // this.controls.enableRotate = false;
      if (this.deviceDetector.isMobile()) this.controls.enableRotate = false;
      this.controls.mouseButtons = {
        LEFT: THREE.MOUSE.RIGHT
      }

      this.controls.enablePan = false;
      this.controls.minDistance = 1700;
      this.controls.maxDistance = this.deviceDetector.isMobile() ? 4500 : 3200;

      this.controls.update();
    } catch (err) { }

  }

  addStat() {
    this.stats = new Stats();
    document.body.appendChild(this.stats.dom);
  }

  bindEvents() {
    window.addEventListener('resize', this.onWindowResize.bind(null, event, this), false);
  }

  playOnFullScreen() {
    let t = this;
    let elem = document.getElementById('container');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem['mozRequestFullScreen']) { /* Firefox */
      elem['mozRequestFullScreen']();
    } else if (elem['webkitRequestFullscreen']) { /* Chrome, Safari & Opera */
      elem['webkitRequestFullscreen']();
    } else if (elem['msRequestFullscreen']) { /* IE/Edge */
      elem['msRequestFullscreen']();
    }

    window.dispatchEvent(new Event('resize'));

  }

  addText(text, type, object3D, position = new THREE.Vector3(0, 0, 0), rotation = new THREE.Euler(0, 0, 0), scale = new THREE.Vector3(1, 1, 1)) {
    return new Promise((resolve, reject) => {
      for (let mesh of this.wheel.children) {
        if (mesh.name == type)
          this.wheel.remove(mesh);
      }
      var t = this;
      var loader = new THREE.FontLoader();
      loader.load('../../assets/fonts/gentilis_bold.typeface.json', function (font) {
        var textGeo = new THREE.TextGeometry(`${text} %`, {
          font: font,
          size: 40,
          height: 2
        });

        var material = [
          new THREE.MeshBasicMaterial({ color: 0xffffff, overdraw: 0.5 }),
          new THREE.MeshBasicMaterial({ color: 0x000000, overdraw: 0.5 })
        ]

        var mesh = new THREE.Mesh(textGeo, material);
        mesh.position.copy(position);
        mesh.rotation.copy(rotation);
        mesh.scale.copy(scale);

        mesh.rotation.x += -90 * degree;
        mesh.name = type;
        // mesh.rotation.y = 180 * degree;

        // var direction = new THREE.Vector3(0, -1, 0);
        // var axis = new THREE.Vector3(0, 0, 1);
        // var angle = Math.PI / 30;

        // t.bendService.set(direction, axis, angle).modify(textGeo);


        textGeo.computeBoundingBox();
        textGeo.computeVertexNormals();

        t.textMeshes.push(mesh);
        object3D.add(mesh);
        resolve(true);
      });
    });
  }


  addActiveToCard(i) {
    this.cardAnimation = false;
    this.isCardSelected = true;
    this.playButtonSound();
    this.removeActiveFromCard();
    this.isCardActive[i] = true;
    setTimeout(() => {
      this.cardAnimation = true;
    }, 1);

    this.selectedCard = `../../assets/images/select-card${i}.png`
  }

  removeActiveFromCard() {
    for (let j = 0; j < this.isCardActive.length; j++)
      this.isCardActive[j] = false;
  }

  confirmBet() {
    this.playButtonSound();
    this.isBetModalOpened = false;
    this.isConfirmBetModalOpened = true;
  }

  betConfirmed(flag) {
    this.playButtonSound();
    if (!flag) {
      this.isConfirmBetModalOpened = false;
      return;
    }
    if (this.betInfo.hasOwnProperty('betId') && this.selectedCard.length) {
      const params = {
        betId: this.betInfo['betId'],
        choosenCard: Number(this.selectedCard.match(/\d+/)[0])
      }
      this.gameService.placeBet(params)
        .takeUntil(componentDestroyed(this))
        .subscribe(res => {
          this.betInfo = Object.assign(this.betInfo, res);
          this.isConfirmBetModalOpened = false;
          this.roulettPhysics.set(this.selectedProbability, this.betInfo['result']);
          this.serverCard = `../../assets/images/select-card${this.betInfo['serverCard']}.png`
          this.rotateWheel();
        });
    }
  }

  closeWinModel() {
    this.playButtonSound();
    this.isWinModelOpened = false;
  }

  closeLooseModel() {
    this.playButtonSound();
    this.isLooseModelOpened = false;
  }

  updateBalance(isWin) {
    if (isWin) {
      this.userInfo['balance'] = Math.floor(+this.userInfo['balance'] + this.winAmount);
    } else {
      this.userInfo['balance'] = +this.userInfo['balance'] - this.selectedBetAmount;
      this.bankBalance += this.selectedBetAmount;
    }
  }

  flush() {
    cancelAnimationFrame(this.animateId);
    this.controls.dispose();
    this.scene.dispose();
    if (this.scene2) this.scene2.dispose();
    if (this.casinoAudio.isPlaying) this.casinoAudio.disconnect();
    if (this.buttonClickAudio.isPlaying) this.buttonClickAudio.disconnect();
    if (this.wheelSpinAudio.isPlaying) this.wheelSpinAudio.disconnect();
    if (this.betAudion.isPlaying) this.betAudion.disconnect();
    if (this.betAudion.isPlaying) this.betAudion.disconnect();
    if (this.looseAudio.isPlaying) this.looseAudio.disconnect();
    if (this.collectAudio.isPlaying) this.collectAudio.disconnect();

    Array.from(document.getElementsByTagName('canvas')).forEach(element => {
      element.outerHTML = '';
    });

    Object.keys(this).forEach((key) => {
      if (typeof this[key].dispose === 'function') {
        this[key].dispose();
      }
      this[key] = null;
    });
  }
}
